export default class Tabs {

	constructor(node, config = {}) {
		this.index = -1;
		this.node = node;

		this.config = Object.assign({
			contentsActiveClass: 'tabs__tab--active',
			contentsClass      : 'tabs__tab',
			interactiveClass   : 'tabs--interactive',
			navClass           : 'tabs__nav',
			navItemClass       : 'tabs__nav-item',
			navItemActiveClass : 'tabs__nav-item--active',
			navLinkClass       : 'tabs__nav-link',
		}, config);

		if (!this.node || this.node.classList.contains(this.config.interactiveClass)) {
			return;
		}

		this.hashMap = {};

		this.nav = this.node.querySelector(`.${this.config.navClass}`);
		const navItems = Array.from(this.node.querySelectorAll(`.${this.config.navItemClass}`));
		const navLinks = Array.from(this.node.querySelectorAll(`.${this.config.navLinkClass}`));

		this.tabs = Array.from(this.node.querySelectorAll(`.${this.config.contentsClass}`)).map((content, index) => {
			const link = navLinks[index];
			const navItem = navItems[index];
			const hash = link.getAttribute('href').replace(/^#/, '');

			content.setAttribute('role', 'tabpanel');
			content.setAttribute('tabindex', -1);

			this.hashMap[hash] = index;

			return {
				opened: false,
				content,
				hash,
				link,
				navItem,
			}
		});

		this.nav.addEventListener('click', (e) => {
			let target = e.target;

			while (target && target !== this.nav) {
				if (target.classList.contains(this.config.navLinkClass) && target.hash) {
					e.preventDefault();
					this.goToHash(target.hash);
					break;
				}

				target = target.parentNode;
			}
		});

		if (window.location.hash) {
			this.goToHash(window.location.hash, false);
		}

		window.addEventListener('hashchange', () => this.goToHash(window.location.hash));
		window.addEventListener('popstate', () => this.goToHash(window.location.hash));

		if (this.index === -1) {
			this.goTo(0, false);
		}

		this.node.classList.add(this.config.interactiveClass);
	}

	goToHash(hash, history = true) {
		hash = hash.replace(/^#/, '');

		if (this.hashMap[hash] > -1) {
			this.goTo(this.hashMap[hash], history);
		}
	}

	goTo(index, history = true) {
		if (this.index > -1) {
			if (this.tabs[this.index].navItem) {
				this.tabs[this.index].navItem.classList.remove(this.config.navItemActiveClass);
			}

			this.tabs[this.index].content.classList.remove(this.config.contentsActiveClass);
			this.tabs[this.index].content.setAttribute('tabindex', '-1');
			this.tabs[this.index].content.removeAttribute('aria-selected');
		}

		this.index = index;

		if (!this.tabs[this.index]) {
			return;
		}

		if (this.tabs[this.index].navItem) {
			this.tabs[this.index].navItem.classList.add(this.config.navItemActiveClass);
		}

		this.tabs[this.index].content.classList.add(this.config.contentsActiveClass);
		this.tabs[this.index].content.setAttribute('aria-selected', 'true');
		this.tabs[this.index].content.removeAttribute('tabindex', '-1');
		this.tabs[this.index].content.focus();

		if ( history && window.location.hash !== `#${this.tabs[this.index].hash}`) {
			window.history.replaceState( '', '', `#${this.tabs[this.index].hash}` );
		}

		this.node.dispatchEvent( new CustomEvent('tabs:change') );
	}

	open(index, history) {
		this.tabs[index].opened = true;
		this.tabs[index].content.classList.add(this.config.contentsOpenClass);
		this.goTo(index, history);

		this.node.dispatchEvent( new CustomEvent('tabs:open') );
	}

	close(index) {
		this.tabs[index].opened = false;
		this.tabs[index].content.classList.remove(this.config.contentsOpenClass);
		this.node.dispatchEvent( new CustomEvent('tabs:close') );
	}

	toggle(index) {
		this.tabs[index].opened ? this.close(index) : this.open(index);
		this.node.dispatchEvent( new CustomEvent('tabs:toggle') );
	}

}
